var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoostCollagen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M18,36 C8.0588745,36 0,27.9411255 0,18 C0,8.0588745 8.0588745,0 18,0 C27.9411255,0 36,8.0588745 36,18 C36,27.9411255 27.9411255,36 18,36 Z",
    id: "path-1-boost"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GFP-Imagery",
    transform: "translate(-314.000000, -252.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/36px/Boost-Collagen",
    transform: "translate(316.000000, 254.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-1-boost"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.03,
    fill: "#27CAE3",
    xlinkHref: "#path-1-boost"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    strokeWidth: 2,
    d: "M18,37 C7.50658975,37 -1,28.4934102 -1,18 C-1,7.50658975 7.50658975,-1 18,-1 C28.4934102,-1 37,7.50658975 37,18 C37,28.4934102 28.4934102,37 18,37 Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeOpacity: 0.04,
    stroke: "#00ADC6",
    strokeWidth: 1,
    d: "M18,35.5 C27.6649831,35.5 35.5,27.6649831 35.5,18 C35.5,8.33501688 27.6649831,0.5 18,0.5 C8.33501688,0.5 0.5,8.33501688 0.5,18 C0.5,27.6649831 8.33501688,35.5 18,35.5 Z",
    strokeLinejoin: "square"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25,26.4785 L25,23.9995 L25,22.7225 C25.596,22.3755 26,21.7385 26,20.9995 C26,20.2615 25.596,19.6245 25,19.2775 L25,16.7225 C25.596,16.3755 26,15.7385 26,14.9995 C26,14.2615 25.596,13.6245 25,13.2775 L25,12.1425 L25,10.9995 L25,9.5215 C27.441,11.5405 29,14.5915 29,17.9995 C29,21.4085 27.441,24.4595 25,26.4785 Z M23,27.7855 C21.779,28.4125 20.431,28.8195 19,28.9495 L19,25.9995 L19,25.7225 C19.596,25.3755 20,24.7385 20,23.9995 C20,23.2615 19.596,22.6245 19,22.2775 L19,21.8575 L19,19.7225 C19.596,19.3755 20,18.7385 20,17.9995 C20,17.2615 19.596,16.6245 19,16.2775 L19,14.1425 L19,13.7225 C19.596,13.3755 20,12.7385 20,11.9995 C20,11.2615 19.596,10.6245 19,10.2775 L19,7.0505 C20.431,7.1805 21.779,7.5875 23,8.2145 L23,10.9995 L23,12.1425 L23,13.2775 C22.404,13.6245 22,14.2615 22,14.9995 C22,15.7385 22.404,16.3755 23,16.7225 L23,19.2775 C22.404,19.6245 22,20.2615 22,20.9995 C22,21.7385 22.404,22.3755 23,22.7225 L23,23.9995 L23,27.7855 Z M17,28.9495 C15.569,28.8195 14.221,28.4125 13,27.7855 L13,25.9995 L13,23.8575 L13,22.7225 C13.596,22.3755 14,21.7385 14,20.9995 C14,20.2615 13.596,19.6245 13,19.2775 L13,16.7225 C13.596,16.3755 14,15.7385 14,14.9995 C14,14.2615 13.596,13.6245 13,13.2775 L13,12.9995 L13,8.2145 C14.221,7.5875 15.569,7.1805 17,7.0505 L17,10.2775 C16.404,10.6245 16,11.2615 16,11.9995 C16,12.7385 16.404,13.3755 17,13.7225 L17,14.1425 L17,16.2775 C16.404,16.6245 16,17.2615 16,17.9995 C16,18.7385 16.404,19.3755 17,19.7225 L17,21.8575 L17,22.2775 C16.404,22.6245 16,23.2615 16,23.9995 C16,24.7385 16.404,25.3755 17,25.7225 L17,25.9995 L17,28.9495 Z M11,25.9995 L11,26.4785 C8.559,24.4595 7,21.4085 7,17.9995 C7,14.5915 8.559,11.5405 11,9.5215 L11,12.9995 L11,13.2775 C10.404,13.6245 10,14.2615 10,14.9995 C10,15.7385 10.404,16.3755 11,16.7225 L11,19.2775 C10.404,19.6245 10,20.2615 10,20.9995 C10,21.7385 10.404,22.3755 11,22.7225 L11,23.8575 L11,25.9995 Z M18,4.9995 C15.465,4.9995 13.105,5.7405 11.104,6.9995 L11,6.9995 L11,7.0625 C7.397,9.3765 5,13.4095 5,17.9995 C5,25.1685 10.832,30.9995 18,30.9995 C25.168,30.9995 31,25.1685 31,17.9995 C31,10.8315 25.168,4.9995 18,4.9995 Z",
    id: "Fill-1",
    fillOpacity: 0.65,
    fill: "#27CAE3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoostCollagen);
export default __webpack_public_path__ + "static/media/BoostCollagen.82756d0b1e47cc01dd9fa28a333d69b0.svg";
export { ForwardRef as ReactComponent };